import React from 'react'

const PriceList = () => {
  return (
    <div>PriceList</div>
  )
}

export default PriceList